// Module
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import DOMPurify from "dompurify";

// CSS
import '_Asset/css/User/Page/connect.css';

// API
import { CoListApi } from "_Route/Api";


const ConferenceDt = () => {

  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const sanitizer = DOMPurify.sanitize;

  const [conferenceData, setConferenceData] = useState([])
  useEffect(() => {
    axios.get(CoListApi)
    .then(res => {
      setConferenceData(res.data.result)
    })
    .catch(err => {
      console.error(err, "ERROR...")
    })
  }, [])

  const detailItem = conferenceData.find(key => key.conference_uuid == params.id)
  const itemIdx = conferenceData.findIndex(key => key.conference_uuid == params.id);


  // Prev, Next Button Event
  const prevBtn = () => {
    if (itemIdx === 0) {
      navigate(`/connect/conference`);
    } else {
      navigate(`/connect/conference/list/${conferenceData[itemIdx - 1].conference_uuid}`);
    }
  }
  const nextBtn = () => {
    navigate(`/connect/conference/list/${conferenceData[itemIdx + 1].conference_uuid}`);
  }

  const FormatConv = (date) => {
    const newDate = new Date(date);

    const month = newDate.toLocaleString("en-US", { month: "long" })
    const dt = newDate.getDate();
    const year = newDate.getFullYear();

    return (month + ' ' + dt + ', ' + year)
  }

  return (
    <>
      {/* Visual */}
      <div className="visual connect">
        <div className="section">
          <div className="visualTitGroup">
            <h2 className="visualTit">Conference</h2>
            
            <p className="visualTxt">Get the latest updates and announcements.</p>
          </div>
        </div>
      </div>

      <div className="mainContents">
        <div className="section">
          {
            detailItem !== undefined &&
            <div className="detailArea areaBox">
              <div className="titGroup co">
                <div className="flexBox between">
                  <h2 className="detailTit">{detailItem.conference_title}</h2>
                  <button type="button" onClick={() => navigate(`/connect/conference`)} className="btn sm round_10 black_edge">목록으로</button>
                </div>

                <div className="category">
                  <p>{detailItem.conference_cat}</p>
                  <span>{FormatConv(detailItem.conference_create_date)}</span>
                </div>
              </div>

              <div className="contGroup">
                <span dangerouslySetInnerHTML={{ __html: sanitizer(detailItem.conference_content)}}></span>
                {/* {
                  detailItem.conference_file &&
                  <div className="downloadTxt">
                    <i className="icofont-link"></i>
                    <span>{detailItem.conference_file}</span>
                  </div>
                } */}
              </div>

              <div className="navBtn">
                <button type="button" className="btn sm black_edge i_lt round_10" onClick={() => prevBtn()}><i className="icofont-rounded-left"></i>{itemIdx === 0 ? 'Back to List' : 'Prev'}</button>
                {
                  itemIdx + 1 !== conferenceData.length &&
                  <button type="button" className="btn sm black_edge i_rt round_10" onClick={() => nextBtn()}>Next<i className="icofont-rounded-right"></i></button>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </>
  )
}

export default ConferenceDt;